import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { FormGroup, H2, H4, H6, HTMLSelect } from '@blueprintjs/core';
import { TablePagination, Paper } from '@material-ui/core';
import Chart from 'react-apexcharts';
import MaterialTable from 'material-table';
import { estimatedClass } from '../common';
import { rounded }  from '../../../utils.js';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants.js';

//import { PUBLIC_URL, ANALYTICS_URL } from '../../../constants';

import './Chrono.css';

class ChronoOccsBySubCorpus extends React.PureComponent {

  state = {
    displayType: 'freq', // 'specByTimeId'
    currentCorpus: Object.keys(this.props.data.occsByCorpus)[0],
    height:300,
  }

  initChart=()=> {
    this.setState({ height: 350 });
  }

  onTypeChange = (e) => {
    e.preventDefault();
    this.setState({ displayType: e.target.value });
  }
  onCorpusChange = (e) => {
    e.preventDefault();
    this.setState({ currentCorpus: e.target.value });
  }

  render() {
    const { warningIncompleteExtraction, t } = this.props;
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
    
    const labels={
      'freq':this.props.t('frequency'),
      'relFreq':this.props.t('relFrequency'),      
      'cumu':this.props.t('cumFrequency'),
      'spec':this.props.t('specificity'),
      'timeSpec':this.props.t('timeSpecificity'),
      'size':this.props.t('timeSpanSize'),
    };
    const data = this.props.data.occsByCorpus;
    const type = this.state.displayType ;
    const typeLabel=labels[type];
    const typeLabelLower = typeLabel.toLowerCase();
    
    const disp = data[this.state.currentCorpus].length;
    // data was previously a table of 6-uplets  [num,timeId,freqInTimeId,FreqGlobal,sizeOfTimeId,SizeGlobal]
    // then transformated into object {timeId,freq,spec}

    const selectOptions= Object.keys(data).map ( (corpus) =>  
        <option key={corpus} value={corpus}>{corpus}</option>
    );

    // constructing table element
    const table = (
      <MaterialTable
        columns={[
          { title: t('timeId'), field: 'timeId' },
          { title: typeLabel, field: type, render: rowData => <span className={estimatedClass(rowData[type],warningIncompleteExtraction)}>{rounded(rowData[type])}</span> },
        ]}
        data={data[this.state.currentCorpus]}
        title={typeLabel}
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFileName:typeLabelLower,
          exportAllData: true,
        }}
        components={{
          Pagination: props => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[5, 10, 25, 50, 100, data[this.state.currentCorpus].length]}
            />
          ),
          Container: props => (
            <Paper
              {...props}
              elevation={0}
            />
          ),
        }}
      />
    );

    // prep data for the chart
    const corpora=Object.keys(data);
    const series=[];


    for (var j=0;j<corpora.length;j++) {
        const xyTab=[];
        var corpus=corpora[j];
        if (! data[corpus] || data[corpus].length===0){
          continue;
        }
        //console.log("ajout de la série pour "+realization);
        // time format computation
        const k=data[corpus][0].timeId.split("-")[0].split("/");
        var dateFormat=(k===3)? "yyyy MMM dd" : (k===2) ? "yyyy MMM" : "yyyy";
        for (var i=0;i<data[corpus].length;i++) {
            const point=data[corpus][i];
            const timeId=point.timeId.split("-")[0];
            const ymd=timeId.split( "/");
            const year=ymd[0];
            const month=ymd[1]?ymd[1]:1;
            const day=ymd[2]?ymd[2]:1;
            const val= point[type];
            xyTab.push(
                { x: new Date(year,month,day).getTime(),
                  y: val
                }
            );
        }
        series.push({ 
            name:corpus,
            data:xyTab
        });
    }

    const options = {
        chart: {
        type: 'line',
        //height: 350
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            position :'top'
        },
        tooltip: {
            enabled:true,
            x: {
                show: true,
                format: dateFormat,
                formatter: undefined,
            },
        },
        yaxis: {
            title: {
                text: t(typeLabel),
            },
            labels: {
                formatter: function (y) {
                return rounded(y,2);
                }
            }
        },
        xaxis: {
            type: 'datetime',
            //categories: xTab,
            labels: {
                rotate: -90,
                //datetimeFormatter: {
                //year: 'yyyy',
                //month: "MMM 'yy",
                //day: 'dd MMM',
                //hour: 'HH:mm',
                //},
            },
            
        }
    };


    return(
    <>

      <Paper className="margin-bottom-1-5-rem padding-1-rem">
        <H2>{t('searchResults')}</H2>

        <div className="margin-bottom-1-5-rem">
          <H4><u>{t('detailedStats')}</u></H4>
          <FormGroup label={t('type')} labelFor='type' inline={true}>
          <HTMLSelect id='type' name='type' onChange={this.onTypeChange}>
              <option value='freq'>{t('freqByTimeId')}</option>
              <option value='relFreq'>{t('relFrequency')}</option>
              <option value='cumu'>{t('cumFreqByTimeId')}</option>
              <option value='spec'>{t('specByTimeId')}</option>
              <option value='timeSpec'>{t('timeSpecByTimeId')}</option>
              <option value='size'>{t('timeSpanSize')}</option>
            </HTMLSelect>
          </FormGroup>
        </div>

        <div className="margin-bottom-1-rem">
          <H6><u>{t('evolutionForMoreFrequentReal')}</u></H6>
          <div id="chartOccsBySubCorpus" onClick={this.initChart} >
             <Chart options={options} series={series} height={this.state.height} />
          </div>
        </div>

        <div className="margin-bottom-1-5-rem">
          <H4><u>{t('choseCorpus')}</u></H4>
          <FormGroup label={t('subCorpusName')} labelFor='corpus' inline={true}>
            <HTMLSelect id='corpus' name='corpus' onChange={this.onCorpusChange}>
                {selectOptions}
            </HTMLSelect>
          </FormGroup>
        </div>

        <div className="margin-bottom-1-rem">
          <H4><u>{t('nbTimeSpan')} - {this.state.currentCorpus}</u></H4>
          <ul>
             <li>{t('beginningColon')} {data[this.state.currentCorpus][0].timeId}</li>
             <li>{t('endingColon')} {data[this.state.currentCorpus][disp-1].timeId}</li>
             <li>{t('dispColon')} {Intl.NumberFormat(langFormat).format(disp)}</li>
          </ul>
          
        </div>

        <H6><u>{t('completeResList')}</u></H6>
          {table}
      </Paper>
    </>
    );
  }

}

ChronoOccsBySubCorpus.propTypes = {
  data: PropTypes.object,
  warningIncompleteExtraction: PropTypes.bool,
};

export default withTranslation()(ChronoOccsBySubCorpus);
